export enum MessageState {
  inProgress = 0,
  done,
  faulted,
  readyForInput,
  readyToTransform,
  readyToMap,
  readyForOutput,
  readyForExternalFetch
}
